import { render, staticRenderFns } from "./TabBudgetAccommodation.vue?vue&type=template&id=f6bdacb2&scoped=true"
import script from "./TabBudgetAccommodation.vue?vue&type=script&lang=ts"
export * from "./TabBudgetAccommodation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bdacb2",
  null
  
)

export default component.exports